(function (Drupal, once) {
  'use strict';

  // Resolves the anchor id of an H2 heading. Two editorial placements are
  // supported, mirroring the backend extraction this behaviour replaces:
  //  - direct: <h2 id="my-anchor">Title</h2>;
  //  - CKEditor "anchor" feature fallback:
  //    <h2><a class="ck-anchor" id="my-anchor">Title</a></h2>.
  function resolveAnchorId(h2) {
    var id = (h2.getAttribute('id') || '').trim();
    if (id !== '') {
      return id;
    }
    var anchor = h2.querySelector('a.ck-anchor[id]');
    return anchor ? (anchor.getAttribute('id') || '').trim() : '';
  }

  // Collects { anchor, title } entries from the H2s of the page content,
  // in document order, deduplicated by anchor (first occurrence wins).
  // H2s without an anchor id are skipped (per the US spec) and the scan is
  // scoped to the node content so header/footer headings are never picked
  // up.
  function buildItems(nav) {
    var scope = nav.closest('.node__content') || document;
    var items = [];
    var seen = {};

    scope.querySelectorAll('h2[id]').forEach(function (h2) {
      var anchor = resolveAnchorId(h2);
      var title = h2.textContent.replace(/\s+/g, ' ').trim();
      if (anchor === '' || title === '' || seen[anchor]) {
        return;
      }
      seen[anchor] = true;
      items.push({ anchor: anchor, title: title });
    });

    return items;
  }

  function buildItemElement(item) {
    var li = document.createElement('li');
    li.className = 'nav-menu__item swiper-slide';

    var link = document.createElement('a');
    link.className = 'nav-menu__link';
    link.setAttribute('href', '#' + item.anchor);
    link.setAttribute('data-toc-target', item.anchor);
    link.textContent = item.title;

    li.appendChild(link);
    return li;
  }

  function initCarousel(nav) {
    var carousel = nav.querySelector('.js-nav-menu-carousel');
    var bar = nav.querySelector('.nav-menu__bar');
    if (!carousel || !bar || typeof Swiper === 'undefined') {
      return;
    }

    new Swiper(carousel, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      a11y: {
        enabled: true,
        prevSlideMessage: Drupal.t('Previous section'),
        nextSlideMessage: Drupal.t('Next section')
      },
      navigation: {
        nextEl: bar.querySelector('.nav-menu__nav--next'),
        prevEl: bar.querySelector('.nav-menu__nav--prev')
      }
    });
    bar.classList.add('nav-menu__bar--init');
  }

  Drupal.behaviors.ouigoNavMenu = {
    attach: function attach(context) {
      once('ouigo-nav-menu', '.nav-menu', context).forEach(function (nav) {
        var list = nav.querySelector('.nav-menu__list');
        if (!list) {
          return;
        }

        // Items may be provided server-side (see nav-menu.twig); in that
        // case keep them as-is and only reveal + initialise the carousel.
        var hasServerItems = list.children.length > 0;
        var items = hasServerItems ? [] : buildItems(nav);

        // The bar is hidden by default; reveal it only when at least one
        // entry exists so pages without anchored H2s never show an empty
        // bar.
        if (!hasServerItems && items.length === 0) {
          return;
        }

        items.forEach(function (item) {
          list.appendChild(buildItemElement(item));
        });
        nav.classList.add('nav-menu--ready');
        initCarousel(nav);
      });
    }
  };
})(Drupal, once);
